import request from './ajax'
// 客服登陆
export const login = (data) => request('service/login', 'post', { ...data })
export const check = (data) => request('service/check', 'post', { ...data })
export const reset = (data) => request('service/reset', 'post', { ...data })
export const send = (data) => request('service/send', 'post', { ...data })
//获取阿里云权限信息
export const getAliSts = (data) => request('service/sts' , 'post', { ...data })
